<template>
  <!-- deprecated -->
  <div class="franchise-page__content">
    <section class="franchise-top">
      <!-- <img class="franchise-top__bg" src="/img/fr-top_bg.png"> -->
      <div class="franchise-top__inner container_new">
        <div class="franchise-top__content">
          <figure class="franchise-top__logo">
            <picture>
              <source
                media="(max-width: 768px)"
                srcset="/img/apptown-fr-mob-logo.png"
              />
              <img src="/img/apptown-fr-logo.png" alt="Logo" />
            </picture>
            <!--<img src="/img/apptown-fr-logo.png" alt="Logo">-->
          </figure>
          <h2 class="franchise-top__title fr-title">
            {{ $t('franchisePage.franchiseTitle') }}
          </h2>
          <div class="scroll-fr_btn" @click="scrollTo">
            {{ $t('franchisePage.topBtn') }}
          </div>
        </div>
      </div>
    </section>
    <section class="in-numbers">
      <div class="in-numbers__inner container_new">
        <div class="in-numbers__content">
          <h2 class="in-numbers__title fr-title">
            {{ $t('franchisePage.inNumbersTitle') }}
          </h2>
          <div
            class="in-numbers__items"
            v-html="$t('franchisePage.first')"
          ></div>
          <div class="in-numbers__slider">
            <figure class="in-numbers__slide">
              <img src="/img/in-numbers-slide-1.png" alt="Our store" />
            </figure>
          </div>
        </div>
      </div>
    </section>
    <section class="conception">
      <div class="conception__inner container_new">
        <div class="conception__top">
          <h2 class="conception__title fr-title">
            {{ $t('franchisePage.conceptionTitle') }}
          </h2>
          <div
            class="conception__desc"
            v-html="$t('franchisePage.concept')"
          ></div>
        </div>
        <div class="conception__insta">
          <p class="conception__insta-title">
            <strong>Instagram</strong
            ><a
              href="https://www.instagram.com/apptown.ua/?hl=ua"
              target="_blank"
              >@apptown.ua</a
            >
          </p>
          <ul class="instagram-links" id="instafeed">
            <li class="instaimg">
              <a href="https://www.instagram.com/p/CKQwyNZBg0C/" target="_blank"
                ><img src="/img/insta-1.jpg"
              /></a>
            </li>
            <li class="instaimg">
              <a href="https://www.instagram.com/p/CKORdoXhUhR/" target="_blank"
                ><img src="/img/insta-2.jpg"
              /></a>
            </li>
            <li class="instaimg">
              <a href="https://www.instagram.com/p/CKLjSgTBTvy/" target="_blank"
                ><img src="/img/insta-3.jpg"
              /></a>
            </li>
            <li class="instaimg">
              <a href="https://www.instagram.com/p/CKJAAleBtHx/" target="_blank"
                ><img src="/img/insta-4.jpg"
              /></a>
            </li>
            <li class="instaimg">
              <a href="https://www.instagram.com/p/CKGaHDIBd-s/" target="_blank"
                ><img src="/img/insta-5.jpg"
              /></a>
            </li>
            <li class="instaimg">
              <a href="https://www.instagram.com/p/CKD3Dfuhx67/" target="_blank"
                ><img src="/img/insta-6.jpg"
              /></a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="preference">
      <div class="preference__inner container_new">
        <div class="preference__top">
          <h2 class="preference__title fr-title">
            {{ $t('franchisePage.preferenceTitle') }}
          </h2>
          <div
            class="preference__desc"
            v-html="$t('franchisePage.preferenceDesc')"
          ></div>
        </div>
        <div class="preference__bottom">
          <ul class="preference__list">
            <li class="preference__list-item">
              <img src="/img/pref-1.png" />
              <p>{{ $t('franchisePage.preferenceList-1') }}</p>
            </li>
            <li class="preference__list-item">
              <img src="/img/pref-2.png" />
              <p>{{ $t('franchisePage.preferenceList-2') }}</p>
            </li>
            <li class="preference__list-item">
              <img src="/img/pref-3.png" />
              <p>{{ $t('franchisePage.preferenceList-3') }}</p>
            </li>
            <li class="preference__list-item">
              <img src="/img/pref-4.png" />
              <p>{{ $t('franchisePage.preferenceList-4') }}</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="conditions">
      <div class="conditions__inner container_new">
        <div class="conditions__content">
          <h2 class="conditions__title fr-title">
            {{ $t('franchisePage.conditionsTitle') }}
          </h2>
          <div
            class="conditions__items"
            v-html="$t('franchisePage.conditions')"
          ></div>
        </div>
      </div>
    </section>
    <section class="you-get">
      <div class="you-get__inner container_new">
        <div class="you-get__content">
          <h2
            class="you-get__title fr-title"
            v-html="$t('franchisePage.youGetTitle')"
          ></h2>
          <ul class="you-get__items" v-html="$t('franchisePage.youGet')"></ul>
          <p class="you-get__bottom">
            <strong>{{ $t('franchisePage.youGetBottom') }}</strong>
          </p>
        </div>
      </div>
    </section>
    <section class="be-partners">
      <scroll ref="element">
        <div class="be-partners__inner container_new">
          <div class="be-partners__content">
            <h2 class="be-partners__title fr-title">
              {{ $t('franchisePage.bePartnersTitle') }}
            </h2>
            <p class="be-partners__subtitle">
              {{ $t('franchisePage.bePartnersSubTitle') }}
            </p>
            <div class="be-partners__form">
              <div role="form" class="fr-form">
                <div class="screen-reader-response"></div>
                <form @submit.prevent="onSubmit" class="be-partners-form">
                  <div>
                    <p class="input-wrap">
                      <span class="be-partners-form-wrap your-name"
                        ><input
                          type="text"
                          name="your-name"
                          value=""
                          size="40"
                          class="be-partners-form-control wpcf7-validates-as-required"
                          aria-required="true"
                          aria-invalid="false"
                          :placeholder="$t('franchisePage.form.name') + '*'"
                          v-model="name"
                          @blur="$v.name.$touch()"
                        />
                        <div
                          class="error"
                          v-if="$v.name.$dirty && !$v.name.required"
                        >
                          {{ $t('franchisePage.appealForm.emptyName') }}
                        </div></span
                      >
                    </p>
                    <p class="input-wrap">
                      <span class="be-partners-form-wrap your-city"
                        ><input
                          type="text"
                          name="your-city"
                          value=""
                          size="40"
                          class="be-partners-form-control wpcf7-validates-as-required"
                          aria-required="true"
                          aria-invalid="false"
                          :placeholder="$t('franchisePage.form.city') + '*'"
                          v-model="city"
                          @blur="$v.city.$touch()"
                        />
                        <div
                          class="error"
                          v-if="$v.city.$dirty && !$v.city.required"
                        >
                          {{ $t('franchisePage.appealForm.emptyCity') }}
                        </div></span
                      >
                    </p>
                    <p class="input-wrap">
                      <span class="be-partners-form-wrap your-email"
                        ><input
                          type="text"
                          name="your-email"
                          value=""
                          size="40"
                          class="be-partners-form-control wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                          aria-required="true"
                          aria-invalid="false"
                          placeholder="E-mail*"
                          v-model="email"
                          @blur="$v.email.$touch()"
                        />
                        <div
                          class="error"
                          v-if="$v.email.$dirty && !$v.email.required"
                        >
                          {{ $t('franchisePage.appealForm.emptyMail') }}
                        </div>
                        <div
                          class="error"
                          v-if="$v.email.$dirty && !$v.email.alpha"
                        >
                          {{ $t('franchisePage.appealForm.invalidMail') }}
                        </div></span
                      >
                    </p>
                    <p class="input-wrap">
                      <span class="be-partners-form-wrap your-phone"
                        ><input
                          type="text"
                          name="your-phone"
                          value=""
                          size="40"
                          class="be-partners-form-control wpcf7-validates-as-required wpcf7-validates-as-email"
                          aria-required="true"
                          aria-invalid="false"
                          :placeholder="$t('contactsPage.form.phone') + '*'"
                          @input="phoneMask()"
                          v-model="phone"
                          @blur="$v.phone.$touch()"
                        />
                        <div
                          class="error"
                          v-if="$v.phone.$dirty && !$v.phone.required"
                        >
                          {{ $t('appealForm.emptyPhone') }}
                        </div>
                        <div
                          class="error"
                          v-if="$v.phone.$dirty && !$v.phone.alpha"
                        >
                          {{ $t('appealForm.invalidPhone') }}
                        </div></span
                      >
                    </p>
                  </div>
                  <p v-if="!sent">
                    <input
                      type="submit"
                      :value="$t('contactsPage.form.btn')"
                      class="be-partners-form-control wpcf7-submit"
                      id="be-partners-form-buttom"
                    />
                    <span class="ajax-loader"></span>
                  </p>
                  <div class="success-msg" v-else>
                    <p>{{ $t('appealForm.formSent') }}</p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </scroll>
    </section>
  </div>
</template>

<script>
import Scroll from '@/components/home/Scroll'
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'

export default {
  name: 'Francise',
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      city: '',
      sent: false,
    }
  },
  components: {
    Scroll,
  },
  methods: {
    scrollTo() {
      this.$refs.element.scrollTo()
    },
    onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      } else {
        this.$store
          .dispatch('submitFranchiseForm', {
            name: this.name,
            phone: this.phone,
            email: this.email,
            city: this.city,
          })
          .then(() => {
            this.$v.$reset()
            this.sent = true
            this.name = ''
            this.phone = ''
            this.city = ''
            this.email = ''
            console.log('*OK')
          })
          .catch(() => {
            console.log('*NOT SUBMITTED')
          })
      }
    },
    phoneMask() {
      const x = this.phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/)

      this.phone = !x[2]
        ? x[1]
        : '(' +
          x[1] +
          ') ' +
          x[2] +
          (x[3] ? '-' + x[3] : '') +
          (x[4] ? '-' + x[4] : '')
      this.$v.phone.$touch()
    },
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required,
    },
    city: {
      required,
    },
    email: {
      required,
      alpha: helpers.regex('alpha', /^\S+@\S+\.\S+$/i),
    },
    phone: {
      required,
      alpha: helpers.regex(
        'alpha',
        /\((0)(\d)(\d)\)\s(\d)(\d)(\d)(-)(\d)(\d)(-)(\d)(\d)/i
      ),
    },
  },
}
</script>

<style>
#main {
  overflow: hidden;
}
.franchise-page {
  width: 100%;
  padding: 0px;
  /* overflow: hidden; */
  background: linear-gradient(
    179.11deg,
    #ffffff 0.76%,
    rgba(219, 219, 219, 0.35) 31.89%,
    rgba(248, 248, 248, 0.41) 57.5%,
    rgba(213, 211, 211, 0.77) 97.11%
  );
}
.franchise-page .middle-content {
  padding-bottom: 0;
}
.franchise-page__content {
  /* background: linear-gradient(179.11deg, #FFFFFF 0.76%, rgba(219, 219, 219, 0.35) 31.89%, rgba(248, 248, 248, 0.41) 57.5%, rgba(213, 211, 211, 0.77) 97.11%); */
  /* opacity: 0.5; */
  width: 100%;
}
.container_new {
  max-width: 1200px;
  padding-left: 15px;
  padding-right: 15px;
  margin: 0 auto;
  width: 100%;
}
.franchise-top {
  background-image: url('/img/fr-top_bg.png');
  background-repeat: no-repeat;
  background-position: left -135px;
}
.franchise-top__content {
  color: #1e1e1e;
  max-width: 970px;
  margin: 0 auto;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 250px;
}
.fr-title {
  font-weight: 800;
  font-size: 64px;
  line-height: 101.9%;
  color: #1e1e1e;
}
.franchise-top__title {
  margin-top: 40px;
  margin-bottom: 90px;
}
.scroll-fr_btn {
  display: inline-flex;
  width: 316px;
  height: 68px;
  border-radius: 50px;
  background: #1374e0;
  font-size: 30px;
  line-height: 101.9%;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.franchise-top {
  position: relative;
  overflow: hidden;
}

.franchise-top__bg {
  position: absolute;
  top: -180px;
  left: 0;
  /* max-width: 650px; */
}
.in-numbers {
  font-size: 24px;
  color: #1e1e1e;
  padding-bottom: 200px;
}
.in-numbers__content {
  text-align: center;
}
.in-numbers__title {
  margin-bottom: 50px;
}
.in-numbers-item {
  text-align: center;
}
.in-numbers__bottom {
  text-align: center;
  font-weight: bold;
  margin-bottom: 80px;
}
.in-numbers-item {
  line-height: 1.3;
}
.in-numbers-item strong {
  font-size: 72px;
  font-weight: 800;
  line-height: 1.1;
}
.in-numbers__slider {
  max-width: 795px;
  margin: 0 auto;
}
.conception {
  background-color: #1e1e1e;
  color: #ffffff;
  font-size: 24px;
  padding-top: 70px;
  padding-bottom: 100px;
  position: relative;
}
.conception::before {
  content: url('/img/fr-conc-top.png');
  position: absolute;
  top: -100px;
  left: calc((100vw - 1550px) / 2);
}
.conception__title.fr-title {
  color: #ffffff;
  text-align: center;
  margin-bottom: 50px;
}
.conception__desc {
  max-width: 560px;
  text-align: center;
  margin: 0 auto;
}
#instafeed {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 40px;
  list-style-type: none;
}
.instaimg {
  padding: 0;
}
.instaimg::before {
  display: none;
}
.conception__insta-title {
  font-size: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.conception__insta-title a {
  color: #ffffff;
  font-size: 24px;
  line-height: 1.3;
}
.instaimg img {
  display: block;
  width: 100%;
  height: auto;
  height: 355px;
  object-fit: cover;
}
.conception-item {
  margin-bottom: 50px;
  font-size: 24px;
  line-height: 1.3;
}
.preference {
  position: relative;
  padding-top: 220px;
  color: #1e1e1e;
  padding-bottom: 120px;
  font-size: 24px;
}
.preference::before {
  content: url('/img/fr-conc-bottom.png');
  position: absolute;
  top: -250px;
  right: 0px;
}
.preference__top {
  text-align: center;
}

.preference__desc {
  max-width: 650px;
  margin: auto;
  text-align: center;
  margin-top: 15px;
  font-weight: bold;
}

.preference__desc p {
  line-height: 1.3;
  margin-bottom: 60px;
}

.preference__list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 140px;
  grid-row-gap: 70px;
}

.preference__list-item::before {
  display: none;
}

.preference__list-item img {
  display: block;
  width: 100%;
  height: auto;
}

.preference__list-item {
  padding: 0;
}

.preference__list-item p {
  padding: 0;
  margin-top: 15px;
  font-weight: bold;
}
.conditions {
  background: #1e1e1e;
  color: #fff;
  font-size: 24px;
  line-height: 1.3;
  padding-top: 70px;
  padding-bottom: 70px;
}
.conditions__items {
  text-align: center;
}

.conditions__item {
  padding-bottom: 30px;
}

.conditions__small {
  font-size: 12px;
}

.conditions__title {
  color: #ffffff;
  text-align: center;
  margin-bottom: 40px;
}
.you-get {
  font-size: 24px;
  color: #1e1e1e;
  padding-top: 250px;
  padding-bottom: 150px;
  position: relative;
}

.you-get__title {
  text-align: center;
  margin-bottom: 40px;
}

.you-get__item {
  padding-left: 100px;
  margin-bottom: 20px;
  position: relative;
}

.you-get__item::before {
  content: '';
  display: inline-block;
  width: 13px;
  height: 24px;
  background: #1e1e1e;
  border-radius: unset;
  vertical-align: baseline;
}
.you-get__bottom {
  text-align: center;
}
.you-get::before {
  content: url('/img/you-get-top.png');
  position: absolute;
  top: -250px;
  left: calc((100vw - 1550px) / 2);
}
.be-partners {
  padding-top: 100px;
  padding-bottom: 500px;
  font-size: 24px;
  color: #1e1e1e;
  position: relative;
}
.be-partners::before {
  content: url('/img/be-partn.png');
  position: absolute;
  top: -250px;
  right: calc((100vw - 1550px) / 2);
}
.be-partners__content {
  text-align: center;
}
.be-partners__form {
  max-width: 715px;
  margin: 0 auto;
  margin-top: 70px;
}
.be-partners__form p {
  text-align: center;
}
.be-partners-form .input-wrap {
  width: 100%;
}
.be-partners-form
  .input-wrap
  > .be-partners-form-wrap
  > input.be-partners-form-control {
  width: 100%;
  color: #828282 !important;
  border-radius: unset !important;
  font-size: 24px !important;
  height: 72px !important;
  background-color: #e4e2e2 !important;
  border: 1px solid #1e1e1e !important;
}
.be-partners-form-wrap .error {
  color: red;
  position: absolute;
  top: calc(100% + 25px);
  padding-left: 15px;
}

.be-partners-form-wrap input {
  margin-bottom: 20px;
  margin-left: 0px !important;
  margin-right: 0px;
}

.be-partners-form-wrap {
  position: relative;
}
#be-partners-form-buttom {
  max-width: 320px;
  height: 72px;
  font-size: 24px;
  background-color: #1e1e1e !important;
}
.be-partners::after {
  content: url('/img/bottom-fr.png');
  position: absolute;
  bottom: -400px;
  left: calc(50vw - 450px);
}
@media screen and (max-width: 1550px) {
  .be-partners::before {
    right: 0;
  }
  .preference__list {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
  }
}

@media screen and (max-width: 1200px) {
  .fr-title {
    font-size: 54px;
  }
  .franchise-top {
    background-position: -220px -135px;
  }
  .preference::before {
    right: -200px;
  }
  .be-partners::before {
    right: -250px;
    top: -230px;
  }
  .in-numbers-item strong {
    font-size: 62px;
  }
}
@media screen and (max-width: 992px) {
  .fr-title {
    font-size: 44px;
  }
  .franchise-top {
    background-position: -220px -135px;
  }
  .preference::before {
    right: -200px;
  }
  .be-partners::before {
    right: -250px;
    top: -230px;
  }
  .in-numbers-item strong {
    font-size: 52px;
  }
  .instaimg img {
    height: 255px;
  }
}
@media screen and (max-width: 768px) {
  .fr-title {
    font-size: 34px;
  }
  .franchise-top {
    background-image: url('/img/fr-top-bg-mob.png');
    background-repeat: no-repeat;
    background-position: left -50px;
  }

  .be-partners::after {
    content: url(/img/bottom-fr-mob.png);
    bottom: -120px;
    left: calc(50vw - 150px);
  }
  .instaimg img {
    height: 155px;
  }
  .be-partners::before {
    right: -250px;
    top: -230px;
  }
  .in-numbers-item strong {
    font-size: 42px;
  }
  .you-get__item {
    padding-left: 20px;
  }
  .in-numbers {
    font-size: 16px;
    padding-bottom: 75px;
  }
  .conception {
    font-size: 16px;
    padding-bottom: 40px;
    padding-top: 20px;
  }
  .conception::before {
    content: url(/img/fr-conc-top-mob.png);
    top: -40px;
    left: 0;
  }
  .preference {
    font-size: 16px;
    padding-top: 80px;
  }
  .preference::before {
    right: 0px;
    content: url('/img/fr-conc-bottom-mob.png');
    top: -90px;
  }
  .conditions {
    font-size: 16px;
    padding-bottom: 35px;
  }
  .you-get {
    font-size: 16px;
    padding-top: 70px;
    padding-bottom: 50px;
  }

  .you-get::before {
    content: url('/img/you-get-top-mob.png');
    top: -50px;
    left: 0;
  }
  .be-partners {
    font-size: 16px;
    padding-top: 50px;
    padding-bottom: 200px;
  }
  .be-partners::before {
    content: url('/img/be-partn-mob.png');
    right: 0px;
    top: -85px;
  }
  .scroll-fr_btn {
    font-size: 18px;
    width: 170px;
    height: 46px;
  }
  .conception-item {
    font-size: 16px;
  }
  .franchise-top__content {
    margin-bottom: 100px;
  }
  .you-get__item::before {
    width: 8px;
    height: 15px;
  }
  #be-partners-form-buttom {
    max-width: 220px;
    height: 46px;
    font-size: 16px;
  }
  .be-partners-form
    .input-wrap
    > .be-partners-form-wrap
    > input.be-partners-form-control {
    font-size: 16px !important;
    height: 46px !important;
  }
}
@media screen and (max-width: 600px) {
  .fr-title {
    font-size: 24px;
  }
  .in-numbers-item strong {
    font-size: 24px;
  }
  .preference__list {
    grid-template-columns: 1fr;
  }
  /* .franchise-top {
    background-position: -220px -135px;
  }*/
  #instafeed {
    grid-gap: 20px;
  }
  .instaimg img {
    height: 105px;
  }
  .conception__title.fr-title {
    padding: 0 40px;
  }
  /*.preference::before {
    right: -200px;
  }
  .be-partners::before {
    right: -250px;
    top: -230px;
  }
  .you-get::before {
    left: -155px;
  }*/
  .preference__list-item p {
    text-align: center;
  }
}
</style>
